import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type Filters as NFTFilters } from '@pkg/types';

interface State {
    availableFilters?: NFTFilters;
    filteredResultsCount?: number;
    showHiddenNfts?: boolean;
    hiddenCount?: number;
    visibleCount?: number;
}

interface Actions {
    setShowHiddenNfts: (showHiddenNfts?: boolean) => void;
    clearFilters: () => void;
    setAvailableFilters: (availableFilters: State['availableFilters']) => void;
    setFilteredCounts: (counts: { filteredResultsCount?: number; hiddenCount?: number; visibleCount?: number }) => void;
}

type NFTsFiltersStoreState = Actions & State;

const initialState: State = {
    filteredResultsCount: undefined,
    availableFilters: undefined,
    showHiddenNfts: false,
};

export const useNFTsFiltersStore = create<NFTsFiltersStoreState>()(
    devtools((set) => ({
        ...initialState,
        setShowHiddenNfts: (showHiddenNfts) => set({ showHiddenNfts }),
        setAvailableFilters: (availableFilters) => set({ availableFilters }),
        setFilteredCounts: (counts) =>
            set({
                filteredResultsCount: counts.filteredResultsCount,
                hiddenCount: counts.hiddenCount,
                visibleCount: counts.visibleCount,
            }),
        clearFilters: () => set({ showHiddenNfts: undefined }),
    })),
);
